import React from 'react';
import Info from "./components/Info";
import RoomInfo from "./components/RoomInfo";
import GroupRoomInfo from "./components/GroupRoomInfo";
import "./Details.sass";
import {useHistory, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import TopBar from "./components/TopBar";
import {useGlobal} from "reactn";

const Details = () => {
    const location = useLocation();
    const room = useSelector(state => state.io.room);

    const history = useHistory();

    const back = () => history.replace('/room/' + room._id);

    const openInfo = useGlobal('openInfo')[0];

    const getComponent = () => {
        if(room && room.isGroup) return <GroupRoomInfo/>

        if (location.pathname.startsWith("/room") && room){
            return <RoomInfo/>;
        }

        if (location.pathname.startsWith("/user") && room){
            return <RoomInfo/>;
        }

        if (expand && room) return <RoomInfo/>;
        return <Info/>;
    }

    const expand = location.pathname.endsWith('/info');

    return (
        <div className={`details${expand ? ' expand' : ' customer-detail-visible'} ${openInfo ? ' close-info' : 'open-info'}`}>
            <TopBar back={back} />
            {expand && <TopBar back={back} />}
            {getComponent()}
        </div>
    );
}

export default Details;
